import { createFileRoute } from "@tanstack/react-router"
import { CalendarSubscriptionsPage } from "./calendar/-components/CalendarSubscriptionsPage"

export const Route = createFileRoute("/app/my/calendar-subscriptions")({
  component: CalendarSubscriptionsPage,
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context?.context.t && context.context.t("CalendarSubscriptions"),
    }
  },
})
